// Screens Reducer - ניהול מסכים, פלייליסטים ודשבורדים
const initialState = {
    screens: [],
    playlists: [],
    dashboards: [],
    loading: false,
    error: null,
    creating: false,
    updating: false,
    deleting: false
};

const screensReducer = (state = initialState, action) => {
    switch (action.type) {
        // Fetch Screens - READ
        case 'FETCH_SCREENS_START':
            return {
                ...state,
                loading: true,
                error: null
            };

        case 'FETCH_SCREENS_SUCCESS':
            return {
                ...state,
                screens: action.payload,
                loading: false,
                error: null
            };

        case 'FETCH_SCREENS_FAILURE':
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // Create Screen - CREATE
        case 'CREATE_SCREEN_START':
            return {
                ...state,
                creating: true,
                error: null
            };

        case 'CREATE_SCREEN_SUCCESS':
            return {
                ...state,
                screens: [...state.screens, action.payload.screen],
                playlists: [...state.playlists, action.payload.playlist],
                dashboards: state.dashboards ? [...state.dashboards, action.payload.dashboard] : [action.payload.dashboard],
                creating: false,
                error: null
            };

        case 'CREATE_SCREEN_FAILURE':
            return {
                ...state,
                creating: false,
                error: action.payload
            };

        // Update Screen - UPDATE
        case 'UPDATE_SCREEN_START':
            return {
                ...state,
                updating: true,
                error: null
            };

        case 'UPDATE_SCREEN_SUCCESS':
            return {
                ...state,
                screens: state.screens.map(screen =>
                    screen.screenId === action.payload.screenId ? action.payload : screen
                ),
                updating: false,
                error: null
            };

        case 'UPDATE_SCREEN_FAILURE':
            return {
                ...state,
                updating: false,
                error: action.payload
            };

        // Delete Screen - DELETE
        case 'DELETE_SCREEN_START':
            return {
                ...state,
                deleting: true,
                error: null
            };

        case 'DELETE_SCREEN_SUCCESS':
            return {
                ...state,
                screens: state.screens.filter(screen => screen.screenId !== action.payload.screenId),
                // מחיקת כל הפלייליסטים של המסך
                playlists: state.playlists.filter(playlist =>
                    !action.payload.playlistIds.includes(playlist.playlistId)
                ),
                deleting: false,
                error: null
            };

        case 'DELETE_SCREEN_FAILURE':
            return {
                ...state,
                deleting: false,
                error: action.payload
            };

        // Fetch Playlists
        case 'FETCH_PLAYLISTS_START':
            return {
                ...state,
                loading: true,
                error: null
            };

        case 'FETCH_PLAYLISTS_SUCCESS':
            return {
                ...state,
                playlists: action.payload,
                loading: false,
                error: null
            };

        case 'FETCH_PLAYLISTS_FAILURE':
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // Create Playlist
        case 'CREATE_PLAYLIST_START':
            return {
                ...state,
                creating: true,
                error: null
            };

        case 'CREATE_PLAYLIST_SUCCESS':
            return {
                ...state,
                playlists: [...state.playlists, action.payload.playlist],
                // עדכון המסך עם ה-schedule החדש
                screens: state.screens.map(screen =>
                    screen.screenId === action.payload.screenId
                        ? { ...screen, schedule: action.payload.updatedSchedule }
                        : screen
                ),
                creating: false,
                error: null
            };

        case 'CREATE_PLAYLIST_FAILURE':
            return {
                ...state,
                creating: false,
                error: action.payload
            };

        // Update Playlist
        case 'UPDATE_PLAYLIST_START':
            return {
                ...state,
                updating: true,
                error: null
            };

        case 'UPDATE_PLAYLIST_SUCCESS':
            return {
                ...state,
                playlists: state.playlists.map(playlist =>
                    playlist.playlistId === action.payload.playlistId ? action.payload : playlist
                ),
                updating: false,
                error: null
            };

        case 'UPDATE_PLAYLIST_FAILURE':
            return {
                ...state,
                updating: false,
                error: action.payload
            };

        // Delete Playlist
        case 'DELETE_PLAYLIST_START':
            return {
                ...state,
                deleting: true,
                error: null
            };

        case 'DELETE_PLAYLIST_SUCCESS':
            return {
                ...state,
                playlists: state.playlists.filter(playlist => playlist.playlistId !== action.payload.playlistId),
                // עדכון המסך - הסרת הפלייליסט מה-schedule
                screens: state.screens.map(screen =>
                    screen.screenId === action.payload.screenId
                        ? { ...screen, schedule: action.payload.updatedSchedule }
                        : screen
                ),
                deleting: false,
                error: null
            };

        case 'DELETE_PLAYLIST_FAILURE':
            return {
                ...state,
                deleting: false,
                error: action.payload
            };

        // Fetch Dashboards
        case 'FETCH_DASHBOARDS_START':
            return {
                ...state,
                loading: true,
                error: null
            };

        case 'FETCH_DASHBOARDS_SUCCESS':
            console.log('📦 screensReducer - FETCH_DASHBOARDS_SUCCESS:', {
                dashboardsCount: action.payload?.length || 0,
                dashboards: action.payload?.map(d => ({
                    dashboardId: d.dashboardId,
                    name: d.name,
                    widgetsCount: d.current?.widgets?.length || 0
                }))
            });
            return {
                ...state,
                dashboards: action.payload,
                loading: false,
                error: null
            };

        case 'FETCH_DASHBOARDS_FAILURE':
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // Fetch Single Dashboard
        case 'FETCH_DASHBOARD_START':
            return {
                ...state,
                loading: true,
                error: null
            };

        case 'FETCH_DASHBOARD_SUCCESS':
            return {
                ...state,
                // עדכון או הוספת הדשבורד למערך
                dashboards: state.dashboards
                    ? state.dashboards.some(d => d.dashboardId === action.payload.dashboardId)
                        ? state.dashboards.map(d => d.dashboardId === action.payload.dashboardId ? action.payload : d)
                        : [...state.dashboards, action.payload]
                    : [action.payload],
                loading: false,
                error: null
            };

        case 'FETCH_DASHBOARD_FAILURE':
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // Create Dashboard
        case 'CREATE_DASHBOARD_START':
            return {
                ...state,
                creating: true,
                error: null
            };

        case 'CREATE_DASHBOARD_SUCCESS':
            return {
                ...state,
                dashboards: state.dashboards ? [...state.dashboards, action.payload.dashboard] : [action.payload.dashboard],
                // עדכון הפלייליסט עם הדשבורד החדש
                playlists: state.playlists.map(playlist =>
                    playlist.playlistId === action.payload.playlistId
                        ? { ...playlist, items: action.payload.updatedItems }
                        : playlist
                ),
                creating: false,
                error: null
            };

        case 'CREATE_DASHBOARD_FAILURE':
            return {
                ...state,
                creating: false,
                error: action.payload
            };

        // Update Dashboard
        case 'UPDATE_DASHBOARD_START':
            return {
                ...state,
                updating: true,
                error: null
            };

        case 'UPDATE_DASHBOARD_SUCCESS':
            return {
                ...state,
                dashboards: state.dashboards
                    ? state.dashboards.map(dashboard =>
                        dashboard.dashboardId === action.payload.dashboardId ? action.payload : dashboard
                    )
                    : [action.payload],
                updating: false,
                error: null
            };

        case 'UPDATE_DASHBOARD_FAILURE':
            return {
                ...state,
                updating: false,
                error: action.payload
            };

        // Delete Dashboard
        case 'DELETE_DASHBOARD_START':
            return {
                ...state,
                deleting: true,
                error: null
            };

        case 'DELETE_DASHBOARD_SUCCESS':
            return {
                ...state,
                dashboards: state.dashboards
                    ? state.dashboards.filter(dashboard => dashboard.dashboardId !== action.payload.dashboardId)
                    : [],
                // עדכון הפלייליסט - הסרת הדשבורד
                playlists: state.playlists.map(playlist =>
                    playlist.playlistId === action.payload.playlistId
                        ? { ...playlist, items: action.payload.updatedItems }
                        : playlist
                ),
                deleting: false,
                error: null
            };

        case 'DELETE_DASHBOARD_FAILURE':
            return {
                ...state,
                deleting: false,
                error: action.payload
            };

        // Update Dashboard Local - עדכון דשבורד גם ב-screens.dashboards
        case 'UPDATE_DASHBOARD_LOCAL':
            return {
                ...state,
                dashboards: state.dashboards?.map(dashboard =>
                    dashboard.dashboardId === action.payload.dashboardId
                        ? {
                            ...dashboard,
                            current: {
                                ...dashboard.current,
                                widgets: action.payload.widgets
                            }
                        }
                        : dashboard
                ) || state.dashboards
            };

        // Clear
        case 'CLEAR_SCREENS':
            return initialState;

        default:
            return state;
    }
};

export default screensReducer;
